import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

export default function AdminGrid({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-4">
      <NavLink
        to={"/admin/devices"}
        onClick={() => onClose()}
        className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary "
      >
        <span className="font-medium text-base">{t("devices")}</span>
      </NavLink>
      <NavLink
        to={"/admin/models"}
        onClick={() => onClose()}
        className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary "
      >
        <span className="font-medium text-base">{t("models")}</span>
      </NavLink>
      <NavLink
        to={"/admin/sensors"}
        onClick={() => onClose()}
        className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary "
      >
        <span className="font-medium text-base">{t("sensors")}</span>
      </NavLink>
      <NavLink
        to={"/admin/downtimes"}
        onClick={() => onClose()}
        className="border-border border p-4 rounded-sm flex flex-col gap-2 hover:bg-border hover:text-primary "
      >
        <span className="font-medium text-base">{t("downtime_reasons")}</span>
      </NavLink>
    </div>
  );
}
